<template>
  <div class="member-list-container">
    <div class="member-list-content">
      <div class="member-list-header">
        <h2>用户列表</h2>
        <p>管理系统中的所有注册用户</p>
      </div>
      
      <el-card shadow="hover">
        <div class="member-list-toolbar">
          <el-input
            v-model="searchQuery"
            placeholder="搜索会员（邮箱/昵称）"
            prefix-icon="el-icon-search"
            style="width: 300px; margin-right: 10px"
          />
          <el-button type="primary" @click="refreshList">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
        
        <el-table :data="members" style="width: 100%">
          <el-table-column prop="id" label="ID" width="40" />
          <el-table-column prop="email" label="邮箱" min-width="180" show-overflow-tooltip />
          <el-table-column prop="subscription" label="订阅方案" width="100">
            <template slot-scope="scope">
              <el-tag :type="getSubscriptionType(scope.row.subscription)" size="mini">
                {{ scope.row.subscription || '免费版' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="60">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini">
                {{ scope.row.status ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="注册时间" width="155" show-overflow-tooltip />
          <el-table-column prop="last_login_at" label="最后登录" width="155" show-overflow-tooltip />
          <el-table-column label="操作" width="380" fixed="right">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <el-button size="mini" type="info" @click="viewRecords(scope.row)">
                  <i class="el-icon-document"></i> 查看记录
                </el-button>
                <el-button size="mini" @click="sendEmail(scope.row)">
                  <i class="el-icon-message"></i> 发送邮件
                </el-button>
                <el-button
                  size="mini"
                  :type="scope.row.status ? 'danger' : 'success'"
                  @click="toggleStatus(scope.row)"
                >
                  <i :class="scope.row.status ? 'el-icon-close' : 'el-icon-check'">
                  </i> {{ scope.row.status ? '禁用' : '启用' }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="member-list-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </el-card>
    </div>
    
    <!-- 发送邮件对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="收件邮箱" prop="email">
          <el-input v-model="form.email" disabled />
        </el-form-item>
        <el-form-item label="邮件主题" prop="subject">
          <el-input v-model="form.subject" placeholder="请输入邮件主题" />
        </el-form-item>
        <el-form-item label="邮件内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="6" placeholder="请输入邮件内容" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEmail">发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MemberList',
  data() {
    return {
      members: [],
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '发送邮件',
      form: {
        id: '',
        email: '',
        subject: '',
        content: ''
      },
      rules: {
        subject: [
          { required: true, message: '请输入邮件主题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入邮件内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getMembers()
  },
  methods: {
    getMembers() {
      // 从后端API获取会员列表
      axios.get('/api/admin/members')
        .then(response => {
          if (response.data.code === 200) {
            this.members = response.data.members
            this.total = response.data.members.length
          }
        })
        .catch(error => {
          console.error('获取会员列表失败:', error)
          this.members = []
          this.total = 0
        })
    },
    refreshList() {
      this.currentPage = 1
      this.getMembers()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getMembers()
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.getMembers()
    },
    getSubscriptionType(subscription) {
      const types = {
        '免费版': 'info',
        '月度会员': 'primary',
        '年度会员': 'success',
        '企业版': 'warning'
      }
      return types[subscription] || 'info'
    },
    sendEmail(row) {
      this.form = { id: row.id, email: row.email, subject: '', content: '' }
      this.dialogTitle = '发送邮件'
      this.dialogVisible = true
    },
    submitEmail() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          axios.post('/api/admin/send-email', {
            user_id: this.form.id,
            subject: this.form.subject,
            content: this.form.content
          })
            .then(() => {
              this.$message.success('邮件发送成功')
              this.dialogVisible = false
            })
            .catch(error => {
              const errorMsg = error.response ? error.response.data.detail || error.response.data.message : '发送失败'
              this.$message.error(errorMsg)
            })
        } else {
          return false
        }
      })
    },
    viewRecords(row) {
      this.$router.push({
        path: '/admin/generate-history',
        query: { user_id: row.id }
      })
    }
  }
}
</script>

<style scoped>
.member-list-container {
  padding: 20px 0;
}

.member-list-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.member-list-header {
  margin-bottom: 30px;
}

.member-list-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.member-list-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.member-list-toolbar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.member-list-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.operation-buttons {
  display: flex;
  gap: 10px;
}
</style>